import React from "react";
import { connect } from "react-redux";
import { fetchMe, editMe, editBusiness } from "../../actions/profileActions";
import { changePassword } from "../../actions/authActions";

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
// import Modal from "@mui/material/Modal";

import ModalElement from "../Modal";
import DetailsForm from "./DetailsForm";
import PasswordForm from "./PasswordForm";

import diffInDays from "../helpers/calculations";
import BusinessDetailsForm from "./BusinessDetailsForm";

class Profile extends React.Component {
    state = {
        detailsChangeModal: false,
        passwordChangeModal: false,
        businessChangeModal: false
    }

    componentDidMount() {
        this.props.fetchMe()
    }

    handleDetailsOpen = () => {
        this.setState({ detailsChangeModal: true })
    };

    handlePasswordOpen = () => {
        this.setState({ passwordChangeModal: true })
    };

    handleBusinessDetailsOpen = () => {
        this.setState({ businessChangeModal: true })
    };    

    handleClose = () => {
        this.setState({ detailsChangeModal: false, passwordChangeModal: false, businessChangeModal: false });
    };

    onDetailsSubmit = (formValues) => {
        this.props.editMe(formValues);
        this.handleClose();
    }

    onPasswordSubmit = (formValues) => {
        this.props.changePassword(formValues);
        this.handleClose();
    }

    onBusinessDetailsSubmit = (formValues) => {
        this.props.editBusiness(formValues);
        this.handleClose();
    }    

    renderProfileCard() {
        return (
            <React.Fragment>
                <CardContent>
                    <Typography variant="h6">
                        Profile Details
                    </Typography>
                    <Typography sx={{ fontSize: 14, mb: 3 }} color="text.secondary">
                        This account has {this.props.profile.has_access ? '' : 'not yet'} been activated
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Name
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.profile.firstname + ' ' + this.props.profile.lastname}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Email
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.profile.email}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Role
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.profile.role}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" onClick={this.handleDetailsOpen}>Change</Button>
                </CardActions>
            </React.Fragment>
        )
    }

    renderBusinessCard() {
        return (
            <React.Fragment>
                <CardContent>
                    <Typography variant="h6">
                        Business Details
                    </Typography>
                    <Typography sx={{ fontSize: 14, mb: 3 }} color="text.secondary">
                        This account can {this.props.profile.scopes.includes('management') ? '' : 'not '}change the Business Details 
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Business name
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.business.businessname}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Business registration number
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.business.businessnumber}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Business email address
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.business.business_email}
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Country
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.business.country}
                    </Typography>                    
                    <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                        Street address
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        {this.props.business.street}
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item sm={6}>
                            <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                                Postal code
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                {this.props.business.postcode}
                            </Typography>
                        </Grid>
                        <Grid item sm={6}>
                            <Typography sx={{ fontSize: 14 }} color="primary.main" gutterBottom>
                                City
                            </Typography>
                            <Typography sx={{ mb: 2 }}>
                                {this.props.business.city}
                            </Typography>
                        </Grid>
                    </Grid>                   
                </CardContent>
                <CardActions>
                    <Button size="small" disabled={!this.props.profile.scopes.includes('management')} onClick={this.handleBusinessDetailsOpen}>Change</Button>
                </CardActions>
            </React.Fragment>
        )
    }

    renderPasswordText(passwordDaysOld) {
        if (this.props.profile.auth_flow === 'password') {
            return `The password was last changed ${passwordDaysOld} day${passwordDaysOld === 1 ? '' : 's'} ago`
        }
        if (this.props.profile.auth_flow === 'google') {
            return 'Password change is handled through your Google account'
        }
    }

    renderPasswordCard(passwordDaysOld) {
        return (
            <React.Fragment>
                <CardContent>
                    <Typography variant="h6">
                        Password
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary">
                        {this.renderPasswordText(passwordDaysOld)}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Button size="small" disabled={this.props.profile.auth_flow !== 'password'} onClick={this.handlePasswordOpen}>Change</Button>
                </CardActions>
            </React.Fragment>
        )
    }

   renderDetailsInstruction() {
        if (this.props.profile.auth_flow === 'password') {
            return 'All fields are required'
        }
        if (this.props.profile.auth_flow === 'google') {
            return 'Using Google login you can not change email'
        }
   } 

    renderDetailsModal() {
        return (
            <ModalElement
                modalOpen={this.state.detailsChangeModal}
                handleClose={this.handleClose}
                header='Profile Details'
                instruction={this.renderDetailsInstruction()}
                content={<DetailsForm onSubmit={this.onDetailsSubmit} initialValues={this.props.profile} authFlow={this.props.profile.auth_flow} />}
            />
        )
    }

    renderPasswordModal() {
        return (
            <ModalElement
                modalOpen={this.state.passwordChangeModal}
                handleClose={this.handleClose}
                header='Change Password'
                instruction='All fields are required'
                content={<PasswordForm onSubmit={this.onPasswordSubmit} />}
            />
        )
    }

    renderBusinessDetailsModal() {
        return (
            <ModalElement
                modalOpen={this.state.businessChangeModal}
                handleClose={this.handleClose}
                header='Business Details'
                instruction='All fields with a * are required'
                content={<BusinessDetailsForm onSubmit={this.onBusinessDetailsSubmit} initialValues={this.props.business} />}
            />
        )
    }

    render() {
        if (this.props.isRefreshing) {
            return <div>Loading...</div>
        }
        if (!this.props.profile) {
            return <div>Loading...</div>
        }

        const passwordDaysOld = diffInDays(this.props.profile.password_changed_at, Date.now())
        return (
            <div>
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center'
                    }}
                >
                    {this.renderDetailsModal()}
                    {this.renderPasswordModal()}
                    {this.renderBusinessDetailsModal()}
                    <Grid container spacing={2} sx={{maxWidth: 800}}>
                        <Grid item sm={6}>
                            <Card variant="outlined">{this.renderProfileCard()}</Card>
                            <Card variant="outlined" sx={{ mt: 3 }}>{this.renderPasswordCard(passwordDaysOld)}</Card>
                        </Grid>
                        <Grid item sm={6}>
                            <Card variant="outlined">{this.renderBusinessCard()}</Card>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        isRefreshing: state.auth.isRefreshing,
        profile: state.profile.user,
        business: state.profile.business
    }
}

export default connect(mapStateToProps, { fetchMe, editMe, changePassword, editBusiness })(Profile);